import { useParams } from 'react-router-dom';

export const useGetVehicleId = () => {
  const { id } = useParams<{ id: string }>();
  return Number(id);
};
